export default __webpack_public_path__ + "static/media/vintagedomus.d6c666db.png";